const css = `._9y7kG__fixed{z-index:1;position:sticky;top:0}._9y7kG__listHeader{width:100%;justify-content:space-between;align-items:center;gap:12px;display:flex}._9y7kG__actionsHidden{opacity:0}._9y7kG__actionsHidden:has(:focus-visible){opacity:1}._9y7kG__actionsVisible{opacity:1}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"actionsHidden":"_9y7kG__actionsHidden","fixed":"_9y7kG__fixed","actionsVisible":"_9y7kG__actionsVisible","listHeader":"_9y7kG__listHeader"};
